"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.LayoutController = void 0;
var maps_1 = require("./maps");
var GAP = 20.0; // Gap between comments in pixels
var TOP_MARGIN = 100.0; // Spacing from the top to the first comment in pixels
var OFFSET = -50; // How many pixels from the annotation position should the comments be placed?
var LayoutController = /** @class */ (function () {
    function LayoutController() {
        this.commentElements = new Map();
        this.commentAnnotations = new Map();
        this.commentTabs = new Map();
        this.commentDesiredPositions = new Map();
        this.commentHeights = new Map();
        this.pinnedComment = null;
        this.commentCalculatedPositions = new Map();
        this.isDirty = false;
    }
    LayoutController.prototype.setCommentElement = function (commentId, element) {
        if (element !== null) {
            this.commentElements.set(commentId, element);
        }
        else {
            this.commentElements["delete"](commentId);
        }
        this.isDirty = true;
    };
    LayoutController.prototype.setCommentAnnotation = function (commentId, annotation) {
        this.commentAnnotations.set(commentId, annotation);
        this.commentTabs.set(commentId, annotation.getTab() || null);
        this.updateDesiredPosition(commentId);
        this.isDirty = true;
    };
    LayoutController.prototype.setCommentHeight = function (commentId, height) {
        if (this.commentHeights.get(commentId) !== height) {
            this.commentHeights.set(commentId, height);
            this.isDirty = true;
        }
    };
    LayoutController.prototype.setPinnedComment = function (commentId) {
        this.pinnedComment = commentId;
        this.isDirty = true;
    };
    LayoutController.prototype.updateDesiredPosition = function (commentId) {
        var annotation = this.commentAnnotations.get(commentId);
        if (!annotation) {
            return;
        }
        var currentNodeTop = annotation.getAnchorNode(commentId === this.pinnedComment).getBoundingClientRect().top;
        this.commentDesiredPositions.set(commentId, currentNodeTop !== 0 ? currentNodeTop + document.documentElement.scrollTop + OFFSET : 0);
    };
    LayoutController.prototype.refreshDesiredPositions = function (tab) {
        var _this = this;
        if (tab === void 0) { tab = null; }
        /* Finds the current annotation positions of all the comments on the specified tab */
        var oldDesiredPositions = new Map(this.commentDesiredPositions);
        this.commentAnnotations.forEach(function (_, commentId) {
            if (_this.getCommentTabVisible(tab, commentId)) {
                _this.updateDesiredPosition(commentId);
            }
        });
        // It's not great to be recalculating all positions so regularly, but Wagtail's FE widgets
        // aren't very constrained so could change layout in any number of ways. If we have a stable FE
        // widget framework in the future, this could be used to trigger the position refresh more
        // intelligently, or alternatively once comments is incorporated into the page form, a
        // MutationObserver could potentially track most types of changes.
        if (this.commentDesiredPositions !== oldDesiredPositions) {
            this.isDirty = true;
        }
    };
    LayoutController.prototype.refreshLayout = function () {
        var _this = this;
        /* Updates positions of all comments based on their annotation locations, and resolves any overlapping comments */
        if (!this.isDirty) {
            return false;
        }
        // Build list of blocks (starting with one for each comment)
        var allBlocks = Array.from(this.commentElements.keys()).map(function (commentId) { return ({
            tab: maps_1.getOrDefault(_this.commentTabs, commentId, null),
            position: maps_1.getOrDefault(_this.commentDesiredPositions, commentId, 0),
            height: maps_1.getOrDefault(_this.commentHeights, commentId, 0),
            comments: [commentId],
            containsPinnedComment: _this.pinnedComment !== null && commentId === _this.pinnedComment,
            pinnedCommentPosition: 0,
        }); });
        // Group blocks by tabs
        var blocksByTab = new Map();
        allBlocks.forEach(function (block) {
            var blocks = blocksByTab.get(block.tab) || [];
            blocks.push(block);
            blocksByTab.set(block.tab, blocks);
        });
        // Get location of pinned comment
        var pinnedCommentPosition = this.pinnedComment ?
            this.commentDesiredPositions.get(this.pinnedComment) : undefined;
        var pinnedCommentTab = this.pinnedComment ?
            this.commentTabs.get(this.pinnedComment) : undefined;
        // For each tab, resolve positions of all the comments
        Array.from(blocksByTab.entries()).forEach(function (_a) {
            var e_1, _b, _c;
            var _d = __read(_a, 2), tab = _d[0], blocks = _d[1];
            var pinnedCommentOnThisTab = _this.pinnedComment && pinnedCommentTab === tab;
            // Sort blocks
            blocks.sort(function (block, comparisonBlock) { return block.position - comparisonBlock.position; });
            // Resolve overlapping blocks
            var currentBlocks = blocks;
            var overlaps = true;
            while (overlaps) {
                overlaps = false;
                var newBlocks = [];
                var previousBlock = null;
                try {
                    for (var currentBlocks_1 = (e_1 = void 0, __values(currentBlocks)), currentBlocks_1_1 = currentBlocks_1.next(); !currentBlocks_1_1.done; currentBlocks_1_1 = currentBlocks_1.next()) {
                        var block = currentBlocks_1_1.value;
                        if (previousBlock) {
                            if (previousBlock.position + previousBlock.height + GAP >
                                block.position) {
                                overlaps = true;
                                // Merge the blocks
                                (_c = previousBlock.comments).push.apply(_c, __spreadArray([], __read(block.comments)));
                                if (block.containsPinnedComment) {
                                    previousBlock.containsPinnedComment = true;
                                    previousBlock.pinnedCommentPosition =
                                        block.pinnedCommentPosition + previousBlock.height;
                                }
                                previousBlock.height += block.height;
                                // Make sure comments don't disappear off the top of the page
                                // But only if a comment isn't focused
                                if (!pinnedCommentOnThisTab &&
                                    previousBlock.position < TOP_MARGIN + OFFSET) {
                                    previousBlock.position =
                                        TOP_MARGIN + previousBlock.height - OFFSET;
                                }
                                // If this block contains the focused comment, position it so
                                // the focused comment is in it's desired position
                                if (pinnedCommentPosition &&
                                    previousBlock.containsPinnedComment) {
                                    previousBlock.position =
                                        pinnedCommentPosition -
                                            previousBlock.pinnedCommentPosition;
                                }
                                continue;
                            }
                        }
                        newBlocks.push(block);
                        previousBlock = block;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (currentBlocks_1_1 && !currentBlocks_1_1.done && (_b = currentBlocks_1["return"])) _b.call(currentBlocks_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                currentBlocks = newBlocks;
            }
            // Write positions
            currentBlocks.forEach(function (block) {
                var currentPosition = block.position;
                block.comments.forEach(function (commentId) {
                    _this.commentCalculatedPositions.set(commentId, currentPosition);
                    var height = _this.commentHeights.get(commentId);
                    if (height) {
                        currentPosition += height + GAP;
                    }
                });
            });
        });
        this.isDirty = false;
        return true;
    };
    LayoutController.prototype.getCommentTabVisible = function (tab, commentId) {
        var commentTab = maps_1.getOrDefault(this.commentTabs, commentId, null);
        return commentTab === tab;
    };
    LayoutController.prototype.getCommentVisible = function (tab, commentId) {
        return this.getCommentTabVisible(tab, commentId) && maps_1.getOrDefault(this.commentDesiredPositions, commentId, 1) > 0;
    };
    LayoutController.prototype.getCommentPosition = function (commentId) {
        if (this.commentCalculatedPositions.has(commentId)) {
            return this.commentCalculatedPositions.get(commentId);
        }
        return this.commentDesiredPositions.get(commentId);
    };
    return LayoutController;
}());
exports.LayoutController = LayoutController;
